<template>
  <div class="loading-indicator">
    <q-inner-loading :showing="loading">
      <q-spinner-gears :size="size" :color="color" />
      <span class="q-ml-md">{{ label || defaultLabel }}</span>
    </q-inner-loading>
  </div>
</template>

<script>
import { useI18n } from "ngt-app-core";

export default {
  name: "LoadingIndicator",
  props: {
    label: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "25px",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { translate } = useI18n();
    const defaultLabel = translate("loading");

    return {
      defaultLabel,
    };
  },
};
</script>

<style>
.loading-indicator {
  min-height: 25px;
}
</style>
